"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _reactNotifications = require("react-notifications");
var _axios = _interopRequireDefault(require("axios"));
var _formik = require("formik");
var _core = require("@stt-componentes/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    form: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(3.5)
    },
    radioGroup: {
      display: 'flex'
    },
    tableWrapper: {
      maxHeight: 440,
      overflow: 'auto'
    },
    buttonWrapper: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      paddingTop: '2px'
    }
  };
});
var ORDENACAO = {
  DIRECAO: {
    ASC: 'asc',
    DESC: 'desc'
  },
  CAMPOS: {
    CODIGO: 'codigo',
    NOME_CATEGORIA: 'nome_subcategoria',
    NOME_SUBCATEGORIA: 'nome_categoria',
    NOME_ABREVIADO: 'nome_abreviado'
  }
};
var BuscaCid10 = function BuscaCid10(_ref) {
  var strings = _ref.strings,
    handleAdd = _ref.handleAdd,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    setOpen = _ref.setOpen,
    headers = _ref.headers,
    _ref$multiplos = _ref.multiplos,
    multiplos = _ref$multiplos === void 0 ? false : _ref$multiplos,
    _ref$capCiap = _ref.capCiap,
    capCiap = _ref$capCiap === void 0 ? null : _ref$capCiap;
  var classes = useStyles();
  var UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    texto = _useState2[0],
    setTexto = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    listaCid10 = _useState4[0],
    setListaCid10 = _useState4[1];
  var _useState5 = (0, _react.useState)(global.gConfig.pagination.start || 0),
    _useState6 = _slicedToArray(_useState5, 2),
    page = _useState6[0],
    setPage = _useState6[1];
  var _useState7 = (0, _react.useState)(global.gConfig.pagination.count || 10),
    _useState8 = _slicedToArray(_useState7, 2),
    count = _useState8[0],
    setCount = _useState8[1];
  var _useState9 = (0, _react.useState)(ORDENACAO.DIRECAO.ASC),
    _useState0 = _slicedToArray(_useState9, 2),
    order = _useState0[0],
    setOrder = _useState0[1];
  var _useState1 = (0, _react.useState)(ORDENACAO.CAMPOS.NOME),
    _useState10 = _slicedToArray(_useState1, 2),
    orderBy = _useState10[0],
    setOrderBy = _useState10[1];
  var _useState11 = (0, _react.useState)(0),
    _useState12 = _slicedToArray(_useState11, 2),
    totalRegistros = _useState12[0],
    setTotalRegistros = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    buscando = _useState14[0],
    setBuscando = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    linhasPaginaMudou = _useState16[0],
    setLinhasPaginaMudou = _useState16[1];
  var _useFormikContext = (0, _formik.useFormikContext)(),
    values = _useFormikContext.values,
    submitForm = _useFormikContext.submitForm;
  var handleClose = function handleClose() {
    setOpen(!open);
    reset();
  };
  var reset = function reset() {
    setTexto('');
    setBuscando(false);
    setListaCid10([]);
    resetPageAndSort();
    setCount(global.gConfig.pagination.count || 10);
  };
  var resetPageAndSort = function resetPageAndSort() {
    setPage(global.gConfig.pagination.start || 0);
    setOrder(ORDENACAO.DIRECAO.ASC);
    setOrderBy(ORDENACAO.CAMPOS.NOME);
  };
  var handleChangeTexto = function handleChangeTexto(event) {
    setTexto(event.target.value);
  };
  var handleClickBuscar = function handleClickBuscar() {
    resetPageAndSort();
    buscar(page);
  };
  var handleClickSort = function handleClickSort(campo) {
    var isAsc = orderBy === campo && order === ORDENACAO.DIRECAO.ASC;
    var newOrder = isAsc ? ORDENACAO.DIRECAO.DESC : ORDENACAO.DIRECAO.ASC;
    setOrder(newOrder);
    setOrderBy(campo);
    buscar(page);
  };
  var buscar = function buscar(pagina) {
    var term = texto.trim();
    var url = "".concat(UTILITARIOS_API_BASE_URL, "/cid-10");
    var offset = pagina * count;
    var params = {
      term: term,
      start: offset,
      count: count,
      sort: orderBy,
      direction: order
    };
    if (capCiap) {
      // Filtro implícito com base no capítulo do CIAP-2
      params.ciap2 = capCiap;
    }
    setBuscando(true);
    _axios["default"].get(url, {
      params: params,
      headers: headers
    }).then(function (_ref2) {
      var data = _ref2.data;
      if (data) {
        setTotalRegistros(parseInt(data.data.totalRegistros));
        setListaCid10(data.data.itens);
      }
    })["catch"](function () {
      setListaCid10([]);
      setTotalRegistros(0);
    })["finally"](function () {
      setBuscando(false);
      setLinhasPaginaMudou(false);
    });
  };
  var handleChangePage = function handleChangePage(event, newPage) {
    setPage(newPage);
    buscar(newPage);
  };
  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setCount(event.target.value);
    setPage(global.gConfig.pagination.start || 0);
    setLinhasPaginaMudou(true);
  };
  (0, _react.useEffect)(function () {
    if (linhasPaginaMudou) {
      handleClickBuscar();
    }
  }, [linhasPaginaMudou]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.SttModal, {
    title: strings.buscar,
    open: open,
    outModalClose: handleClose,
    iconClose: handleClose,
    maxWidth: "lg",
    fullWidth: true,
    children: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.form,
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleClickBuscar();
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true,
      xs: 12,
      md: 8
    }, /*#__PURE__*/_react["default"].createElement(_core.SttInput, {
      label: strings.buscar,
      value: texto,
      inputProps: {
        style: {
          textTransform: "uppercase"
        }
      },
      onChange: handleChangeTexto
    })), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true,
      xs: 12,
      md: 1
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.buttonWrapper
    }, /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
      variant: "contained",
      color: "primary",
      nomarginleft: "true",
      onClick: handleClickBuscar
    }, strings.buscar))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.tableWrapper
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTable, {
      stickyHeader: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableHead, null, /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, null, /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
      xsDown: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "10%",
      sortDirection: orderBy === ORDENACAO.CAMPOS.CODIGO ? order : false
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableSortLabel, {
      active: orderBy === ORDENACAO.CAMPOS.CODIGO,
      direction: orderBy === ORDENACAO.CAMPOS.CODIGO ? order : ORDENACAO.DIRECAO.ASC,
      onClick: function onClick() {
        return handleClickSort(ORDENACAO.CAMPOS.CODIGO);
      }
    }, strings.codigo)), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "25%",
      sortDirection: orderBy === ORDENACAO.CAMPOS.NOME_CATEGORIA ? order : false
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableSortLabel, {
      active: orderBy === ORDENACAO.CAMPOS.NOME_CATEGORIA,
      direction: orderBy === ORDENACAO.CAMPOS.NOME_CATEGORIA ? order : ORDENACAO.DIRECAO.ASC,
      onClick: function onClick() {
        return handleClickSort(ORDENACAO.CAMPOS.NOME_CATEGORIA);
      }
    }, strings.categoria)), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "25%",
      sortDirection: orderBy === ORDENACAO.CAMPOS.NOME_SUBCATEGORIA ? order : false
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableSortLabel, {
      active: orderBy === ORDENACAO.CAMPOS.NOME_SUBCATEGORIA,
      direction: orderBy === ORDENACAO.CAMPOS.NOME_SUBCATEGORIA ? order : ORDENACAO.DIRECAO.ASC,
      onClick: function onClick() {
        return handleClickSort(ORDENACAO.CAMPOS.NOME_SUBCATEGORIA);
      }
    }, strings.subcategoria)), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "30%",
      sortDirection: orderBy === ORDENACAO.CAMPOS.NOME_ABREVIADO ? order : false
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableSortLabel, {
      active: orderBy === ORDENACAO.CAMPOS.NOME_ABREVIADO,
      direction: orderBy === ORDENACAO.CAMPOS.NOME_ABREVIADO ? order : ORDENACAO.DIRECAO.ASC,
      onClick: function onClick() {
        return handleClickSort(ORDENACAO.CAMPOS.NOME_ABREVIADO);
      }
    }, strings.nomeAbreviado)), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "10%"
    }, "Selecionar")), /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
      smUp: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "100%",
      colSpan: "2"
    }, strings.cid10)))), /*#__PURE__*/_react["default"].createElement(_core.SttTableBody, null, buscando ? /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
      key: -1
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      colSpan: 5,
      align: "center"
    }, /*#__PURE__*/_react["default"].createElement(_core.SttCircularProgress, null))) : listaCid10.length === 0 ? /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
      key: -1
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      colSpan: 5,
      align: "center"
    }, strings.nenhumRegistroEncontrado)) : listaCid10.map(function (row, index) {
      return /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
        key: index
      }, /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
        xsDown: true
      }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.codigo), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.nome_categoria), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.nome_subcategoria), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.nome_abreviado)), /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
        smUp: true
      }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
        width: "96%"
      }, /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.codigo, ":"), " ", row.codigo), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.categoria, ":"), " ", row.nome_categoria), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.subcategoria, ":"), " ", row.nome_subcategoria), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.nomeAbreviado, ":"), " ", row.nome_abreviado))), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
        align: "center"
      }, /*#__PURE__*/_react["default"].createElement(_core.SttAddButton, {
        id: "btn-confirmar-cid10-".concat(index),
        onClick: function onClick() {
          var repetidos = values['cid10'].filter(function (sigtap) {
            return sigtap.codigo == row.codigo;
          });
          if (repetidos.length) {
            _reactNotifications.NotificationManager.error(strings.cid10AdicionadoAnteriormente);
          } else {
            handleAdd(row);
            if (!multiplos) {
              setOpen(false);
            }
            _reactNotifications.NotificationManager.success(strings.cid10Adicionado);
            submitForm();
          }
        }
      })));
    })))), listaCid10.length > 0 && /*#__PURE__*/_react["default"].createElement(_core.SttTablePagination, {
      rowsPerPageOptions: [10, 20, 40],
      component: "div",
      count: totalRegistros,
      rowsPerPage: count,
      page: page,
      onPageChange: handleChangePage,
      onRowsPerPageChange: handleChangeRowsPerPage,
      labelRowsPerPage: strings.linhasPorPagina,
      labelDisplayedRows: function labelDisplayedRows(_ref3) {
        var from = _ref3.from,
          to = _ref3.to,
          count = _ref3.count;
        return "".concat(from, "-").concat(to, " ").concat(strings.de, " ").concat(count);
      }
    })),
    footer: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
      variant: "outlined",
      color: "primary",
      onClick: handleClose
    }, strings.fechar))
  }));
};
BuscaCid10.propTypes = {
  strings: _propTypes["default"].object.isRequired,
  open: _propTypes["default"].bool,
  setOpen: _propTypes["default"].func.isRequired,
  handleAdd: _propTypes["default"].func.isRequired,
  headers: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(BuscaCid10);